import React from "react";
import PropTypes from "prop-types";
import { useCountry } from "src/client/js/view/hooks";
import { localiseUrlII } from "src/common/utils/format-localised-url";
import "./ShopNavigationTiles.scss";

const ShopNavigationTiles = ({ title, items }) => {
  const country = useCountry();

  return (
    <section
      aria-labelledby="ShopNavigationTiles"
      className="ShopNavigationTiles"
    >
      <div className="SectionHeading">
        <div className="container-guttered">
          <h1 className="SectionHeading__heading SectionHeading__heading--left">
            {title}
          </h1>
        </div>
      </div>
      <div className="container-guttered">
        <div className="ShopNavigationTiles__container">
          {items.map(({ title, image, href }) => (
            <a
              key={title}
              className="ShopNavigationTiles__tile"
              href={localiseUrlII(country, href)}
            >
              <div className="ShopNavigationTiles__tile-container">
                <div className="ShopNavigationTiles__image">
                  <div className="BackgroundImage">
                    <div
                      className="BackgroundImage__image BackgroundImage__image--loaded"
                      style={{
                        backgroundImage: `url(${image.url})`,
                        backgroundPosition: "center center",
                      }}
                    />
                  </div>
                </div>
                <div className="ShopNavigationTiles__content">
                  <p className="ShopNavigationTiles__text">{title}</p>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

ShopNavigationTiles.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      image: PropTypes.shape({
        url: PropTypes.string.isRequired,
        alt: PropTypes.string,
      }),
      href: PropTypes.string.isRequired,
    })
  ),
};

export default ShopNavigationTiles;
